import actions from './actions';
import mutations from './mutations';
import getters from './getters';
export const getDefaultBorderState = () => {
    return {
        parentId: 0,
        borders: []
    };
};
export const state = getDefaultBorderState();
export const border = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
